<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <!--      <div class="table-page-search-wrapper">-->
      <!--        <a-form layout="inline">-->
      <!--          <a-row :gutter="48">-->
      <!--            <a-col :md="8" :sm="24">-->
      <!--              <a-form-item label="sku名称" prop="skuName">-->
      <!--                <a-input v-model="queryParam.skuName" placeholder="请输入sku名称" allow-clear/>-->
      <!--              </a-form-item>-->
      <!--            </a-col>-->
      <!--            <a-col :md="8" :sm="24">-->
      <!--              <a-form-item label="商品名称" prop="goodsId">-->
      <!--                <a-select v-model="queryParam.goodsId"  placeholder="请选择商品">-->
      <!--                  <a-select-option v-for="item in goodsList" :value="item.id">{{item.goodsName}}</a-select-option>-->
      <!--                </a-select>-->
      <!--              </a-form-item>-->
      <!--            </a-col>-->

      <!--            <a-col :md="!advanced && 8 || 24" :sm="24">-->
      <!--              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">-->
      <!--                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>-->
      <!--                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>-->
      <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
      <!--                  {{ advanced ? '收起' : '展开' }}-->
      <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
      <!--                </a>-->
      <!--              </span>-->
      <!--            </a-col>-->
      <!--          </a-row>-->
      <!--        </a-form>-->
      <!--      </div>-->
      <!-- 操作 -->
      <span slot="title" class="card-title">
        <a-button size="small" @click="$router.go(-1)" style="margin-right: 15px">
          <a-icon type="left" />返回
        </a-button>
        <span>商品SKU</span>
      </span>
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['goods:sku:add']">-->
        <!--          <a-icon type="plus" />新增-->
        <!--        </a-button>-->
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['goods:sku:edit']"
        >
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['goods:sku:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <!-- <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        /> -->
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ (current - 1) * size + index + 1 }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="image" slot-scope="text, record">
          <img
            v-viewer
            style="width: 48px; height: 48px; margin-top: 5px; margin-right: 5px"
            v-if="record.image"
            :src="record.image"
            preview="头像"
          />
        </span>
        <span slot="operation" slot-scope="text, record, index">
          <a-divider type="vertical" v-hasPermi="['goods:sku:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['goods:sku:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['goods:sku:remove']" />
          <a @click="handleDelete(record, index)" v-hasPermi="['goods:sku:remove']"> 
            <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
           </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageSku, listSku, delSku, pushWDT } from '@/api/goods/sku'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import TagSelectOption from '@/components/TagSelect/TagSelectOption'
import { listGoodsInfo } from '@/api/goods/goodsInfo'

export default {
  name: 'Sku',
  components: {
    TagSelectOption,
    CreateForm,
  },
  mixins: [tableMixin],
  data() {
    return {
      showCashCoupon: null,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      goodsList: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      //索引indexs
      indexs: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        skuName: null,
        goodsId: null,
        stock: null,
        image: null,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        // {
        //   title: 'SKU编号',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '规格图片',
          dataIndex: 'image',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'image' },
        },
        // {
        //   title: '商品名称',
        //   dataIndex: 'goodsName',
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: '库存',
          dataIndex: 'stock',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '价格',
          dataIndex: 'price',
          ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '原价',
        //   dataIndex: 'originalPrice',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '需积分数',
        //   dataIndex: 'requireScores',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '需现金券数',
          dataIndex: 'cashCoupon',
          ellipsis: true,
          align: 'center',
          colSpan:(this.$route.query.showCashCoupon?0:1)
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  activated() {
    // this.initGoods()
    this.queryParam.goodsId = this.$route.query.goodsId
    // 闲橙健康进来不显示需现金券数列
     //this.showCashCoupon = this.$route.query.showCashCoupon
     //if (this.showCashCoupon) {
     //  this.columns = this.columns.filter((col) => col.dataIndex !== 'cashCoupon')
     //}
     //console.log(this.columns, '修改后columns')
    this.getList()
  },

  created() {

  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    /** 查询商品规格信息列表 */
    getList() {
      this.loading = true
      pageSku(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },
    initGoods() {
      listGoodsInfo().then((res) => {
        this.goodsList = res.data
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        skuName: undefined,
        goodsId: undefined,
        stock: undefined,
        image: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      // 列表顶部删除indexs
      if (this.selectedRowKeys.length) {
        const indexList = this.selectedRowKeys.map((item) => {
          return this.list.findIndex((i) => i.id === item)
        })
        this.indexs = indexList
          .filter((item) => item !== -1)
          .map((ind) => {
            return (this.current - 1) * this.size + ind + 1
          })
      }
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row, index) {
      var that = this
      const ids = row.id || this.ids
      const inds = (this.current - 1) * this.size + index + 1
      const indexs = inds || this.indexs.sort((a, b) => a - b)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + indexs + '的数据',
        onOk() {
          let data = []
          if (row.id) {
            data.push({ id: row.id })
          } else {
            that.ids.map((id) => data.push({ id: id }))
          }
          return delSku(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          // that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'goods/sku/export',
            {
              ...that.queryParam,
            },
            `商品规格信息_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
